import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ElectronAppInfo } from 'types/general.types';

export interface ElectronState {
  info?: ElectronAppInfo;
}

export const electronInitialState: ElectronState = {};

const slice = createSlice({
  name: 'electron',
  initialState: electronInitialState,
  reducers: {
    setAppInfoAction(state, { payload }: PayloadAction<ElectronAppInfo>) {
      state.info = payload;
    },
  },
});

export const { setAppInfoAction } = slice.actions;

export const electronReducer = slice.reducer;
